import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { PatientWithEventsEvent } from '@/jsonapi/PatientWithEvents'

enum ModelTypes {
  PatientData = 'simple-patient',
}

enum ModelTypeNames {
  PatientData = 'simplePatient',
}

export interface PatientAttributes {
  lastName: string
  firstName: string
  status: 'active' | 'completed'
  careGiverFirstName: string
  careGiverLastName: string
  patientEvent: PatientWithEventsEvent | null
  liveEvents: PatientWithEventsEvent[] | null
  site: string
  phoneNumber: string
  timezone: string
  lastVibeConnectionTimestamp: number
  lastTrackerConnectionTimestamp: number
  lastLocationName: string
  roomNumber: string
  lastConnectionSharedRoomId: string
}

export interface PatientSchema {
  id: string
  attributes: PatientAttributes
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientData]: {
      attributes: {
        lastName: { type: 'string' },
        firstName: { type: 'string' },
        status: { type: 'string' },
        careGiverFirstName: { type: 'string' },
        careGiverLastName: { type: 'string' },
        patientEvent: { type: 'object' },
        liveEvents: { type: 'array' },
        phoneNumber: { type: 'string' },
        timezone: { type: 'string' },
        site: { type: 'string' },
        lastVibeConnectionTimestamp: { type: 'number' },
        lastTrackerConnectionTimestamp: { type: 'number' },
        lastLocationName: { type: 'string' },
        roomNumber: { type: 'string' },
        lastConnectionSharedRoomId: { type: 'string' },
      },
    },
  },
}

export async function getPatientDataQuery() {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patients')
      return q.findRecords(ModelTypes.PatientData)
    })
    .catch(() => {
      console.log('fetch failed in get patients ')
    })
}

export async function getPatientDataByPatientIdQuery({ patientId }: { patientId: string }) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  console.log('Before calling find record for patient', patientId)
  return remote
    .query(q => q.findRecords(ModelTypes.PatientData).filter({ attribute: 'id', value: patientId }))
    .catch(() => console.log('fetch failed in get patient', patientId))
}
